import { API_RESEND_REGISTRATION_MAIL_URL } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";

interface IResponse {
    success: boolean;
}

export const useResendRegistrationEmailMutation = () => {
    return useMutation<IResponse>(API_RESEND_REGISTRATION_MAIL_URL);
};
